<template>
    <div class="imgCard">
        <div class="left">
            <p class="t1 __line2">{{item.title || ''}}</p>
            <p class="t2 __line2">{{item.description}}</p>
        </div>
        <div class="right">
            <img :src="item.banner" alt="" srcset="">
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        goListPath(item) {
            this.$dataStatistics({ event_type: 'click', page_title: '分类' }, JSON.stringify({ title: `${item.name}`, id: item.id }));
            this.$router.push(`/childList?id=${item.id}`);
        },
    }
};
</script>
<style lang="less" scoped>
.imgCard {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: linear-gradient(270deg, #FFFFFF 0%, #FFFFFF 100%);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid;
    border-image: linear-gradient(270deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
    margin-bottom: 12px;

    .left {
        .t1 {
            font-size: 16px;
            color: #333333;
            line-height: 24px;
        }

        .t2 {
            font-size: 14px;
            color: #9F9F9F;
            line-height: 20px;
            margin-top: 8px;
        }
    }

    .right {
        width: 121px;
        height: 80px;
        border-radius: 4px 4px 4px 4px;
        flex-shrink: 0;
        margin-left: 16px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 4px 4px 4px 4px;
        }
    }
}
</style>